/**
 * 通用代码
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'
import XEUtils from "xe-utils";

export async function loadBaseCodeData(no) {
	let baseCodeArr = await request(api.temp.BASE_CODE + '?typeNo=' + no, METHOD.GET);
	return (baseCodeArr.data && baseCodeArr.data.dtlList) ? baseCodeArr.data.dtlList.filter((val) => {  return val.isUse === true}).map((val) => {
		return Object.assign(val, {
			label: val.codeName,
			value: val.codeId
		});
	}) : [];
}

/**
 * 根据当前用户所属的经销商分公司查询 可管理区域
 */
export async function loadAreaTreeData() {
	let treeData = await request(api.temp.AREA_CODE, METHOD.GET);
	treeData.data.map((i) => {
		return i.isLeaf = !!i.isLeaf
	})
	return XEUtils.toArrayTree(treeData.data, {key: 'areaId', parentKey: 'parentAreaId', children: 'children'});
}

/**
 * 根据当前用户所属的经销商分公司查询 可管理区域
 */
export async function loadAreaTreeCasData() {
	let treeData = await request(api.temp.AREA_CODE, METHOD.GET);
	treeData.data.forEach((i) => {
		delete i.isLeaf
	})
	return XEUtils.toArrayTree(treeData.data, {key: 'areaId', parentKey: 'parentAreaId', children: 'children'});
}
// 城市
export async function loadCityTreeCasData() {
	let treeData = await request(api.temp.CITY_CODE, METHOD.GET);
	treeData.data.forEach((i) => {
		delete i.isLeaf
	})
	return XEUtils.toArrayTree(treeData.data, {key: 'areaId', parentKey: 'parentAreaId', children: 'children'});
}

export function dealTreeNoChild(arr) {
	arr.forEach(item => {
		if (item.children.length) {
			dealTreeNoChild(item.children)
		} else {
			delete item.children
		}
	})
}

export default {loadBaseCodeData, loadAreaTreeData, dealTreeNoChild}
